import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import BuildersForm from './BuildersForm';
import { colors, typography } from '../../styles';

const styles = css`
.pageIntroduction {
  text-align: center;
  max-width:900px;
  margin:0;
  background:whitesmoke;
  padding:40px;
  margin:0 auto 60px auto;
  p {
    font:400 16px/2 ${typography.SansSerif};
    @media (min-width: 768px) {
      font:400 18px/2 ${typography.SansSerif};
    }
  }
}
.blockquote {
  padding:60px 40px;
  font:700 36px/1.3 ${typography.SansSerif};
  color:white;
  text-align: center;
  margin-bottom:60px;
  @media (min-width: 768px) {
    font:700 48px/1.3 ${typography.SansSerif};
    padding:100px;
  }
  @media (min-width: 1199px) {
    font:700 54px/1.3 ${typography.SansSerif};
  }
}
  main {
    padding:20px 0;
    @media (min-width: 480px) {
      padding:40px 0;
    }
    @media (min-width: 768px) {
      padding:60px 0;
    }
  }

  .formWrapper {
    background:whitesmoke;
    padding:30px;
    border-top:8px solid ${colors.color2};
    @media (min-width: 768px) {
      padding:100px;
    }
  }
`;

const formStyles = css``;

// const formStyles = css``;

function ForBuilders({ page }) {
  return (
    <div className={styles}>
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <main>
          <div className="container">
            <div className="pageIntroduction">
              {
                get(page, 'body_copy') &&
                <div className="PageReadable_Body" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} />
              }
            </div>
          </div>
          {
              page.block_quote.map(item => (
                <div key={item.text} className="blockquote" style={{ backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.25) 0%,rgba(0,0,0,0.25) 100%), url(${buildThumbnailUrl(item.image.contentUrl, { width: 1800 })})` }}>
                  <div className="container" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'text'))} />
                </div>
              ))
            }
          <div className="container">
            <div className="formWrapper">
              <BuildersForm className={formStyles} noRedirect />
            </div>
          </div>
        </main>
      </PageWrapper>
    </div>
  );
}

ForBuilders.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'for_builders',
})(ForBuilders);



// WEBPACK FOOTER //
// ./src/pages/ForBuilders/index.js